/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Text } from "@nordcloud/gnui";

function Footer() {
  return (
    <div className="footer">
      <Text
        css={{
          fontSize: ".75rem",
          color: "#5E5E75",
          textAlign: "center",
          flexShrink: 0,
          margin: "1rem",
        }}
      >
        OVERLAY by Nordcloud Oy © {new Date().getFullYear()}
      </Text>
    </div>
  );
}

export default Footer;
